export const CODE_INSIGHTS_REPORTS_PAGE_SIZE = 10;
export const CODE_INSIGHTS_ANNOTATIONS_PAGE_SIZE = 100;
export const REPO_SIZE_LIMIT_CONFLUENCE_URL =
  'https://support.atlassian.com/bitbucket-cloud/docs/reduce-repository-size/#Rewind-history-to-undo-large-commits';
